<template>

<PantalladeCarga v-if="$store.state.cargando == true" titulo="Recuperando Presupuesto..."></PantalladeCarga>
</template>

<script>

import PantalladeCarga from './PantalladeCarga.vue'
import Prices from './MatrixPrices'

export default {
  name: 'LoadPrices',
  components: {
    PantalladeCarga
  },
  props: {

    idPresupuesto: String,
    urlPresupuestos: String,
    conversionValue: Number,
    name: String

  },
  data: function () {
              return {
                urlPresupuestoWeb: false,
                loaded: false
              }
  },
  beforeMount: async function(){

    this.CambiarCargando(true);

    //Cargando los Precios de la Base de Datos de Presupuestos
    let datosPresupuesto = await Prices.VerDatosPresupuesto(this.urlPresupuestos, this.idPresupuesto);

    if (datosPresupuesto.status == "OK")
    {


      //Parte de Seguros con RC
      if (datosPresupuesto.data.RC){

        await this.ActualizarRC(datosPresupuesto.data.RC);
        
      }

      let Precios = datosPresupuesto.data.preciosJSON;

      if (datosPresupuesto.data.telefono){

        await this.ActualizarTelefono(datosPresupuesto.data.telefono);

      }

      if (datosPresupuesto.data.fechaNacimiento){

        if (datosPresupuesto.data.fechaNacimiento != ""){

          await this.ActualizarFechaNacimientoTomador(datosPresupuesto.data.fechaNacimiento);

        }


      }


      if (datosPresupuesto.data.nombreTomador){

        if (datosPresupuesto.data.apellidosTomador != ""){

            let nombre = datosPresupuesto.data.nombreTomador;
            let apellidos = datosPresupuesto.data.apellidosTomador;

            let tabla = {

              "nombre": nombre.toUpperCase(),
              "apellidos": apellidos.toUpperCase(),
              "completo": nombre.toUpperCase()+" "+apellidos.toUpperCase(),
              "tipo": "PF"
            };

            await this.ActualizarNombreTomador(tabla);
  
          } else {

            let nombre = datosPresupuesto.data.nombreTomador;
            let tabla = {

              "nombre": nombre.toUpperCase(),
              "tipo": "PJ"
            };

            await this.ActualizarNombreTomador(tabla);

          }
      }

      

      
      
      let fechaEfecto = datosPresupuesto.data.fechaEfecto;

      let diasHastaEfecto = await Prices.diasHastaEfecto(fechaEfecto);


      if (diasHastaEfecto >= 1)
      {

        let diasPromo = String((diasHastaEfecto+5));

        await this.CambiarPromo(diasPromo);


      }


      if (datosPresupuesto.data.tipoTomador){

        if (datosPresupuesto.data.tipoTomador == "Particular"){

          this.urlPresupuestoWeb = "/presupuesto/familias/"+this.idPresupuesto;
          this.ActualizarTipoTomador("familias");
          this.ActualizarIdPresupuesto(this.idPresupuesto);


        } else {

          this.urlPresupuestoWeb = "/presupuesto/pymes/"+this.idPresupuesto;
          this.ActualizarTipoTomador("pymes");
          this.ActualizarIdPresupuesto(this.idPresupuesto);


        }
      } else {

        this.urlPresupuestoWeb = "/contratacion-online/";

      }

      if (Precios != "")
      {

        let NuevaMatrizPrecios = JSON.parse(Precios);


        await this.ActualizarPrecios(NuevaMatrizPrecios);

      }


      if (this.$store.state.ProductoSeleccionadoEnParrilla)
      {

        console.log("Existe la seleccion en parilla");

        if (this.$store.state.ProductoSeleccionadoEnParrilla != "" && this.$store.state.ProductoSeleccionadoEnParrilla != null)
        {

          await this.SeleccionarProducto(this.$store.state.ProductoSeleccionadoEnParrilla);


        }

      } else {

        console.log("NO Existe la seleccion en parilla");

        if (datosPresupuesto.data.paqueteSeleccionado.seguroInicial){

          await this.SeleccionarProducto(datosPresupuesto.data.paqueteSeleccionado.seguroInicial);


        }

        if (datosPresupuesto.data.paqueteSeleccionado.addons){

          await this.AddonsParrilla(datosPresupuesto.data.paqueteSeleccionado.addons);
        }


        if (datosPresupuesto.data.paqueteSeleccionado.periodoSeleccionado){

          await this.resetPeriodoSeleccionado(datosPresupuesto.data.paqueteSeleccionado.periodoSeleccionado);
        }



        if (datosPresupuesto.data.numeroAsegurados){

          await this.ActualizarNumeroAsegurados(datosPresupuesto.data.numeroAsegurados);

        }

      }


      if (datosPresupuesto.data.email){


        await this.ActualizarEmail(datosPresupuesto.data.email);
        
      }


      if (datosPresupuesto.data.asegurados){


        await this.ActualizarAsegurados(datosPresupuesto.data.asegurados);
        
      }




      await this.PonerVisible(true);



      

    }

    this.CambiarCargando(false);

  },

  mounted: async function(){

    this.loaded = true;

  },

  methods: {

      ActualizarPrecios : async function(Precios){

        try {

          await this.$store.commit('ActualizarPreciosPresupuesto', Precios);
          let NuevoPricing = await this.CambiarPricingPagina();
          this.$store.commit('ActualizarPricing', NuevoPricing);

          if (this.conversionValue)
          {

            //dataLayer.push({'conversionValue': this.conversionValue});

          }

          if (this.name)
          {

            //dataLayer.push({'event': this.name+"Conversion"});

          }

          
        } catch (error) {


          console.log(error);
          
        }

      },

      PonerVisible : async function(Visible){

        this.$emit('PonerVisible', Visible);

      },

      SeleccionarProducto : async function(codigo){


        this.$store.commit('seleccionarProductoParrilla', codigo);    

      },

      AddonsParrilla : async function(extensiones){

        this.$store.commit('resetAddonsParrilla', extensiones);

      },



      resetPeriodoSeleccionado : async function(extensiones){

        this.$store.commit('resetPeriodoSeleccionado', extensiones);

      },


      ActualizarNumeroAsegurados : async function(asegurados){

        this.$store.commit('ActualizarNumeroAsegurados', asegurados);

      },

      ActualizarEmail : async function(email){

        this.$store.commit('ActualizarEmail', email);

      },


      ActualizarAsegurados : async function(asegurados){

        this.$store.commit('ActualizarAsegurados', asegurados);

      },

      ActualizarTipoTomador : async function(tipo){

        this.$store.commit('ActualizarTipoTomador', tipo);

      },

      ActualizarIdPresupuesto : async function(id){

        this.$store.commit('ActualizarIdPresupuesto', id);

      },


      ActualizarNavbar : async function(navbar){

        this.$store.commit('ActualizarNavbar', navbar);

      },

      CambiarCargando : async function(cargando){

        this.$store.commit('CambiarCargando', cargando);

      },


      CambiarPromo: async function(dias){


        this.$store.commit('CambiarDiasPromoDinamica', dias);
        

      },

      ActualizarTelefono: async function(valor){


        this.$store.commit('ActualizarTelefono', valor);
        

      },
      
      ActualizarRC: async function(rc){


        this.$store.commit('ActualizarRC', rc);
        

      },

      ActualizarFechaNacimientoTomador: async function(valor){


        this.$store.commit('ActualizarFechaNacimientoTomador', valor);
        

      },


      ActualizarNombreTomador: async function(valor){


        this.$store.commit('ActualizarNombreTomador', valor);
        

      },
    
      CambiarPricingPagina : async function(){

        try {

          if (this.$store.state.Precios)
          {

            let precios = this.$store.state.Precios[0];

            if (this.$store.state.Pricing.products)
            {

              let productos = this.$store.state.Pricing.products;

              var MatrixProductos = [];

              for (let producto of productos){


                let codigo = producto.cod;


                for (let MPrecio of precios){


                    if (MPrecio.codigo == codigo)
                    {

                      var precioNuevo = MPrecio.precios.Mensual;
                      var CodigoNuevo = MPrecio.codigo;

                      if (precioNuevo > 0)
                      {

                        break;

                      } else {

                        var precioNuevo = MPrecio.precios.Anual;

                        if (precioNuevo > 0)
                        {

                          break;

                        }

                      }

                     

                    }


                }

                if (precioNuevo > 0 && codigo == CodigoNuevo)
                {

                  var productoNuevo = producto;
                      productoNuevo.price = precioNuevo;
                      productoNuevo.url = "/contratacion-online/";
                      productoNuevo.note = "Contrata en menos de 2 minutos";
                      productoNuevo.button = "<u><b>Contratar Online</b></u><br> <i>en menos de 2 minutos</i>";

                  MatrixProductos.push(productoNuevo);

                }


              }


              if (MatrixProductos.length > 0)
              {


                  return MatrixProductos;

              }


            }

          }

          return this.$store.state.Pricing.products;
          
        } catch (error) {


          return this.$store.state.Pricing.products;
          
        }
      }
    }
  }
</script>
